<template>
    <figure
        v-if="splashVideoUrl"
        id="cz2__splash-video"
        class="cz2__splash-video--wrapper"
    >
        <h2 class="cz2__splash-video-heading">
            {{ $t('SPLASH_VIDEO_HEADING') }}
        </h2>

        <div class="cz2__splash-video-container">
            <video
                controls
                playsinline
                :src="splashVideoUrl"
                :poster="splashVideoPoster"
                loading="lazy"
                preload="metadata"
                ref="splashVideo"
                class="cz2__splash-video"
            />

            <transition name="cz2__fade">
                <button
                    v-show="showPlayIcon"
                    @click="playVideo"
                    type="button"
                    :aria-label="$t('SPLASH_VIDEO_PLAY')"
                    class="cz2__splash-video-play"
                >
                    <span class="cz2__splash-video-play-icon" />
                </button>
            </transition>
        </div>
    </figure>
</template>

<style lang="scss">
    @import '../style/variables';

    #cz2.cz2 {
        .cz2__splash-video--wrapper {
            margin: 0;
            width: 100%;

            .cz2__splash-video-heading {
                margin: 48px 0 24px 0;
                font-family: 'Proxima Nova';
                font-weight: 900;
                font-size: 32px;
                font-style: italic;
                text-align: center;
            }

            .cz2__splash-video-container {
                position: relative;
            }

            .cz2__splash-video {
                width: 100%;
                height: auto;
                // Aspect ratio from mocks
                aspect-ratio: 120 / 67;

                // Aspect ratio from ciricut video
                // aspect-ratio: 584 / 1071;

                // @include respond-above(sm) {
                //     // Aspect ratio from ciricut video
                //     aspect-ratio: 1087 / 337;
                // }
            }

            .cz2__splash-video-play {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .cz2__splash-video-play-icon {
                width: 64px;
                height: 64px;
                background-image: url('../assets/icons/landing-video-play.svg');
                background-size: contain;
            }

            @include respond-above(md) {
                .cz2__splash-video-play-icon {
                    width: 128px;
                    height: 128px;
                }

                @-moz-document url-prefix() {
                /* Hide Firefox big dumb play icon by making our icon even bigger */
                    .cz2__splash-video-play-icon {
                        width: 152px;
                        height: 152px;
                    }
                }
            }
        }
    }
</style>

<script>
    export default {
        name: 'SplashVideo',

        props: {
            splashVideoUrl: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                showPlayIcon: true,
            };
        },

        computed: {
            globalSettings() {
                return this.$store.state.customizer.globalSettings?.blueprint?.custom;
            },

            splashVideoPoster() {
                const url = this.globalSettings?.['fun-splash-video-poster'];

                if (!url || url === 'none') {
                    return null;
                }

                return url;
            },
        },

        methods: {
            playVideo() {
                this.togglePlayIcon();
                this.$refs.splashVideo.play();
            },

            togglePlayIcon() {
                this.showPlayIcon = !this.showPlayIcon;
            },
        },

        mounted() {
            this.$refs.splashVideo?.addEventListener('ended', this.togglePlayIcon);
        },

        beforeDestroy() {
            this.$refs.splashVideo?.removeEventListener('ended', this.togglePlayIcon);
        },
    };
</script>
